import $ from "jquery"

$(document).ready(function() {
    $(document).mouseup(function(e) {
        var container = $(".ebook__modal");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            $('.ebook__modal').removeClass('active');
        }
    });
    $('.ebook__content a').on('click', function(e) {
        e.preventDefault();
        $('.ebook__modal').addClass('active');
    })

    $('.js-ebook-close').on('click', function(e) {
        e.preventDefault();
        $('.ebook__modal').removeClass('active');
    })

    $('.ebook__modal').on('click', function(e) {
        e.stopPropagation();
    });
});
